module.exports = __webpack_public_path__ + "static/img/chu.54bbd622.png";